import z from "zod";

export const getLocationAddressLine = (location) =>
  location?.formatted_address ||
  location?.address_line ||
  location?.address ||
  "";

export const getLocationSuite = (location) =>
  location?.suite || location?.apartment || "";

export const addressSchemaToJson = (value) => {
  const formattedAddress =
    value.formattedAddress || value.address_line || value.address;

  return {
    address_id: value.addressId,
    formatted_address: formattedAddress,
    location: value.location,
    zip_code: value.zipCode,
    is_out_of_working_zone: value.isZipCodeOutOfService,
  };
};

export const addressFromJson = (json) => {
  if (!json) return null;
  const formattedAddress =
    json.formatted_address || json.address_line || json.address;

  return {
    addressId: json.address_id,
    formattedAddress,
    location: json.location,
    zipCode: json.zip_code,
    isZipCodeOutOfService: json.is_out_of_working_zone,
  };
};

export const resolveDefaultAddressJson = (entity) => {
  if (!entity) return null;
  if (entity.default_address) return entity.default_address;
  // Fallback for older API responses during migration.
  if (entity.home_address) return entity.home_address;

  const addresses = Array.isArray(entity.addresses) ? entity.addresses : null;
  if (!addresses?.length) return null;

  return (
    addresses.find((address) => address.is_default_address) ||
    addresses[0] ||
    null
  );
};

export const addressFromGooglePlaceJson = (json) => {
  const zipCode = json.addressComponents.find((i) =>
    i.types.find((j) => j === "postal_code"),
  )?.longText;

  const country = json.addressComponents.find((i) =>
    i.types.find((j) => j === "country"),
  )?.shortText;

  return {
    addressId: json.id,
    formattedAddress: json.formattedAddress,
    location: { lat: json.location.lat(), lng: json.location.lng() },
    zipCode: zipCode,
    country: country,
  };
};

export const addressSchemaField = z
  .looseObject({})
  .nullable()
  .refine((val) => val, { message: "Address is required" });
